export interface TextDatatypeInterface extends String {
  data?: string;
}

export class TextDatatypeClass extends String implements TextDatatypeInterface {
  data?: string;
}
